import React from 'react'
import './Navbar.css'
import '../../node_modules/bootstrap-icons/font/bootstrap-icons.css'

function navbar() {
    document.addEventListener('click', e => {
    const isDropdownButton = e.target.matches("[data-dropdown-button]")
    if (!isDropdownButton && e.target.closest("[data-dropdown]") !=null) return

    let currentDropdown
    if (isDropdownButton){
        currentDropdown = e.target.closest("[data-dropdown]")
        currentDropdown.classList.toggle("active")
    }
    document.querySelectorAll("[data-dropdown].active").forEach(dropdown => {
        if (dropdown === currentDropdown) return
        dropdown.classList.remove("active")
    })
});
function responsiveMenu() {
  var x = document.getElementById("ourmenu");
  if (x.className === "navbar") {
    x.className += " responsive";
  } else {
    x.className = "navbar";
  }
};
  return(
  <div className='menu'>
      <div className='identity'>
        <img src='https://static.igem.wiki/teams/4247/wiki/logos-03.png' width='40px' alt='Logo'/>
        <p> <a href='/ucopenhagen' style={{ textDecoration: 'none',color:'black' }}>UCopenhagen</a></p>
      </div>
      <div className="nav-icon"><span style={{fontSize:'30px', margin: 'auto 0.5rem auto auto', color: 'hsla(225, 40%, 18%,1)',cursor:'pointer'}} onClick={responsiveMenu}><i className="bi bi-list"></i></span></div>
      <nav className='navbar' id='ourmenu'>
        <ul className='navbar-items'><a href='/ucopenhagen'><button className='dropbutton'>Home</button></a></ul>
        <ul className='navbar-items' data-dropdown>
          <button className='dropbutton' data-dropdown-button>Team&nbsp;<i className="bi bi-caret-down-fill" data-dropdown-button style={{fontSize:'0.8rem'}}></i></button>
          <ul className='navbar-dropdown'>
            <li className='dropdown-items'><a href='/ucopenhagen/team'>Team</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/attributions'>Attributions</a></li>
          </ul>
        </ul>
        <ul className='navbar-items' data-dropdown>
          <button className='dropbutton' data-dropdown-button>Project&nbsp;<i className="bi bi-caret-down-fill" data-dropdown-button style={{fontSize:'0.8rem'}}></i></button>
          <ul className='navbar-dropdown'>
            <li className='dropdown-items'><a href='/ucopenhagen/description'>Description</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/design'>Design</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/model'>Model</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/results'>Results</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/engineering'>Engineering Success</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/implementation'>Implementation</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/contribution'>Contribution</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/experiments'>Experiments</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/proof-of-concept'>Proof of concept</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/notebook'>Notebook</a></li>
          </ul>
        </ul>
        <ul className='navbar-items' data-dropdown>
        <button className='dropbutton' data-dropdown-button>Parts&nbsp;<i className="bi bi-caret-down-fill" data-dropdown-button style={{fontSize:'0.8rem'}}></i></button>
          <ul className='navbar-dropdown'>
            <li className='dropdown-items'><a href='/ucopenhagen/parts'>Parts</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/part-collection'>Parts Collection</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/improve'>Improvement</a></li>
          </ul>
        </ul>
        <ul className='navbar-items'><a href='/ucopenhagen/safety'><button className='dropbutton'>Safety</button></a></ul>
        <ul className='navbar-items' data-dropdown>
          <button className='dropbutton' data-dropdown-button>Engagement&nbsp;<i className="bi bi-caret-down-fill" data-dropdown-button style={{ fontSize: '0.8rem' }}></i></button>
          <ul className='navbar-dropdown'>
            <li className='dropdown-items'><a href='/ucopenhagen/human-practices'>Human Practices</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/communication'>Education and Communication</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/collaborations'>Collaborations</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/partnership'>Partnership</a></li>
          </ul>
        </ul>
        <ul className='navbar-items' data-dropdown>
          <button className='dropbutton' data-dropdown-button>Special Prizes&nbsp;<i className="bi bi-caret-down-fill" data-dropdown-button style={{ fontSize: '0.8rem' }}></i></button>
          <ul className='navbar-dropdown' data-dropdown-button>
            <li className='dropdown-items'><a href='/ucopenhagen/sustainable'>Sustainability</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/education'>Education</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/entrepreneurship'>Entrepreneurship</a></li>
            <li className='dropdown-items'><a href='/ucopenhagen/inclusivity'>Inclusivity</a></li>
          </ul>
        </ul>
        <ul className='navbar-items'><a href='/ucopenhagen/awards'><button className='dropbutton' data-dropdown-button>Awards</button></a></ul>
      </nav>
  </div>
  
)}

export default navbar